import { render, staticRenderFns } from "./UpdateVehicleType.vue?vue&type=template&id=dc14ee8c&"
import script from "./UpdateVehicleType.vue?vue&type=script&lang=js&"
export * from "./UpdateVehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports